import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=19b6255c"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=19b6255c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports